/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftIdAppointmentsAcceptMutationResponse, PostApiBarberShiftIdAppointmentsAcceptPathParams, PostApiBarberShiftIdAppointmentsAccept400, PostApiBarberShiftIdAppointmentsAccept401, PostApiBarberShiftIdAppointmentsAccept403, PostApiBarberShiftIdAppointmentsAccept404, PostApiBarberShiftIdAppointmentsAccept500 } from "../entities/PostApiBarberShiftIdAppointmentsAccept";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberShiftIdAppointmentsAccept } from "../api/postApiBarberShiftIdAppointmentsAccept";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberShiftIdAppointmentsAcceptMutationKey = () => [{ url: '/api/barber/shift/:id/appointments/accept' }] as const

export type PostApiBarberShiftIdAppointmentsAcceptMutationKey = ReturnType<typeof postApiBarberShiftIdAppointmentsAcceptMutationKey>

export function postApiBarberShiftIdAppointmentsAcceptMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = postApiBarberShiftIdAppointmentsAcceptMutationKey()
        return mutationOptions<PostApiBarberShiftIdAppointmentsAcceptMutationResponse, ResponseErrorConfig<PostApiBarberShiftIdAppointmentsAccept400 | PostApiBarberShiftIdAppointmentsAccept401 | PostApiBarberShiftIdAppointmentsAccept403 | PostApiBarberShiftIdAppointmentsAccept404 | PostApiBarberShiftIdAppointmentsAccept500>, {id: PostApiBarberShiftIdAppointmentsAcceptPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return postApiBarberShiftIdAppointmentsAccept(id, config)
          },
        })

}

/**
 * @description Мастер вызывает клиента
 * @summary Вызвать клиента
 * {@link /api/barber/shift/:id/appointments/accept}
 */
export function usePostApiBarberShiftIdAppointmentsAccept<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberShiftIdAppointmentsAcceptMutationResponse, ResponseErrorConfig<PostApiBarberShiftIdAppointmentsAccept400 | PostApiBarberShiftIdAppointmentsAccept401 | PostApiBarberShiftIdAppointmentsAccept403 | PostApiBarberShiftIdAppointmentsAccept404 | PostApiBarberShiftIdAppointmentsAccept500>, {id: PostApiBarberShiftIdAppointmentsAcceptPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberShiftIdAppointmentsAcceptMutationKey()

          const baseOptions = postApiBarberShiftIdAppointmentsAcceptMutationOptions(config) as UseMutationOptions<PostApiBarberShiftIdAppointmentsAcceptMutationResponse, ResponseErrorConfig<PostApiBarberShiftIdAppointmentsAccept400 | PostApiBarberShiftIdAppointmentsAccept401 | PostApiBarberShiftIdAppointmentsAccept403 | PostApiBarberShiftIdAppointmentsAccept404 | PostApiBarberShiftIdAppointmentsAccept500>, {id: PostApiBarberShiftIdAppointmentsAcceptPathParams["id"]}, TContext>
          

          return useMutation<PostApiBarberShiftIdAppointmentsAcceptMutationResponse, ResponseErrorConfig<PostApiBarberShiftIdAppointmentsAccept400 | PostApiBarberShiftIdAppointmentsAccept401 | PostApiBarberShiftIdAppointmentsAccept403 | PostApiBarberShiftIdAppointmentsAccept404 | PostApiBarberShiftIdAppointmentsAccept500>, {id: PostApiBarberShiftIdAppointmentsAcceptPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberShiftIdAppointmentsAcceptMutationResponse, ResponseErrorConfig<PostApiBarberShiftIdAppointmentsAccept400 | PostApiBarberShiftIdAppointmentsAccept401 | PostApiBarberShiftIdAppointmentsAccept403 | PostApiBarberShiftIdAppointmentsAccept404 | PostApiBarberShiftIdAppointmentsAccept500>, {id: PostApiBarberShiftIdAppointmentsAcceptPathParams["id"]}, TContext>
      
}